import { render } from "./Crash.vue?vue&type=template&id=4fac413e&scoped=true"
import script from "./Crash.vue?vue&type=script&lang=js"
export * from "./Crash.vue?vue&type=script&lang=js"

import "./Crash.vue?vue&type=style&index=0&id=4fac413e&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fac413e"]])

export default __exports__